import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import type { ComponentPropsWithoutRef } from "react";

import { useCircleV4 } from "@/react/hooks/useCircleV4";

import { AttachmentGalleryComponent } from "./AttachmentGalleryComponent";
import { AttachmentGalleryUIKitComponent } from "./AttachmentGalleryUIKitComponent";

type AttachmentGalleryUIKitComponentProps = ComponentPropsWithoutRef<
  typeof AttachmentGalleryUIKitComponent
>;

const AttachmentGalleryUIKit = ModalManager.create(
  (props: AttachmentGalleryUIKitComponentProps) => (
    <AttachmentGalleryUIKitComponent {...props} />
  ),
);

type AttachmentGalleryComponentProps = Omit<
  ComponentPropsWithoutRef<typeof AttachmentGalleryComponent>,
  "open" | "onOpenChange"
>;

const AttachmentGallery = ModalManager.create(
  (props: AttachmentGalleryComponentProps) => {
    const drawer = useModal();

    return (
      <AttachmentGalleryComponent
        {...props}
        open={drawer.visible}
        onOpenChange={open => {
          if (!open) {
            void drawer.hide();
          }
        }}
      />
    );
  },
);

export const useAttachmentGallery = () => {
  const { isCircleV4 } = useCircleV4();

  const modalComponent = isCircleV4
    ? AttachmentGallery
    : AttachmentGalleryUIKit;

  return useModal(modalComponent);
};
